
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contactus",
      function () {
        return require("private-next-pages/contactus/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contactus"])
      });
    }
  